import { isNodeList } from "./isNodeList";

export function unwrap(els) {
  var elsNew = (isNodeList(els)) ? els : [els];
  for (var i = elsNew.length; i--;) {
    var el = elsNew[i];

    // get the element's parent node
    var parent = el.parentNode;
    
    // move all children out of the element
    while (el.firstChild) { 
      parent.insertBefore(el.firstChild, el); 
    }
    
    // remove the empty element
    parent.removeChild(el);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/bower_components/go-native/src/gn/unwrap.js
// module id = 57
// module chunks = 0 1